<template>
  <Wrapper />
</template>

<script lang="ts">
import { computed, defineComponent, provide, Ref, ref, watchEffect } from "vue";

import Wrapper from "./components/Wrapper.vue";

import { AnalyticEvents } from "@fresh8/types/src/analytics";

import {
  createLayoutContext,
  provideLayoutSync
} from "@fresh8/vue-utils/src/dimensionSync";

import { installFonts } from "@fresh8/vue-utils/src/installFonts";
import { useHandleAnalytics, useAnalyticsContext } from "./lib/analytics";
import { useNoEvents } from "./hooks/useNoEvents";
import { useAnalytics } from "./hooks/useAnalytics";
import {
  AdTagContext,
  injectAdTag
} from "@fresh8/ad-data-composition/src/brand";
import { injectMarketCards } from "./composition/card-creation";

export default defineComponent({
  components: {
    Wrapper
  },
  setup() {
    const adTagContext = injectAdTag() || ({} as AdTagContext);

    const $handleAnalytics = useHandleAnalytics();
    installFonts();
    provideLayoutSync(createLayoutContext());
    useNoEvents();

    const { firstThreeMarketIds } = injectMarketCards();

    const resivedVisbileEvent = ref(false);

    const { handleViewed } = useAnalytics({}, "Impression");

    const teamFeatureFlags = computed(
      () => adTagContext.teamFeatureFlags.value
    );

    const refireAfter = computed(() => {
      const operator = adTagContext.operator.value?._id;
      const pixelReimpressionEnabled =
        teamFeatureFlags.value?.pixelReimpression;

      if (pixelReimpressionEnabled && operator) {
        const refireAfter =
          adTagContext.adTag.value?.tracking[operator].refireAfter || 0;

        return refireAfter;
      }

      return 0;
    });

    if (!teamFeatureFlags?.value?.disableLegacyAnalytics)
      handleViewed(firstThreeMarketIds.value, refireAfter.value);

    window.addEventListener(
      "message",
      e => {
        if (e.data.type === "ad_visible" && !resivedVisbileEvent.value) {
          resivedVisbileEvent.value = true;
          $handleAnalytics(
            AnalyticEvents.VIEWABLE,
            "Impression",
            undefined,
            undefined,
            undefined,
            refireAfter.value
          );
          window.parent.postMessage({ type: "f8_stop_visible" }, "*");
        }
      },
      true
    );

    return {};
  }
});
</script>

<style></style>
